import { getData } from "../newApis/apiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { useQuery } from "react-query";

interface CustomerOrderSearchDetails {
  Page: number;
  PageSize: number;
  DateFrom?: string | null;
  DateTo?: string | null;
  CustomerId: number;
}

const getCustomerOrdersDetails = async ({
  Page,
  PageSize,
  DateFrom,
  DateTo,
  CustomerId,
}: CustomerOrderSearchDetails) => {
  let queryParams = `?customer_id=${CustomerId}&page=${Page}&page_size=${PageSize}`;
  if (DateFrom) {
    queryParams = `${queryParams}&from_date=${DateFrom}`;
  }
  if (DateTo) {
    queryParams = `${queryParams}&to_date=${DateTo}`;
  }

  const data = await getData(
    `${ajaxEndpoints.ORDERS_DATA_OF_CUSTOMER}${queryParams}`
  );
  return data;
};

export const useCustomerOrdersDetails = ({
  Page,
  PageSize,
  DateFrom,
  DateTo,
  CustomerId,
}: CustomerOrderSearchDetails) => {
  return useQuery(
    [
      { Page, PageSize, DateFrom, DateTo, CustomerId },
      "getCustomerOrdersDetails",
    ],
    getCustomerOrdersDetails,
    {
      refetchOnWindowFocus: false,
      enabled: CustomerId ? true : false,
    }
  );
};
